
import { useEffect } from "react";
import { Navigation } from "@/components/Navigation";
import { CommunityTabs } from "@/components/community/CommunityTabs";
import { ScriptureJourneys } from "@/components/scripture/ScriptureJourneys";
import { CommunityHeader } from "@/components/community/CommunityHeader";

export default function Journeys() {
  // Ensure the page scrolls to top on load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1A1A25] to-[#0F111A] text-white pb-52">
      <div className="container py-8">
        <CommunityHeader />
        
        <div className="max-w-3xl mx-auto mt-8">
          <ScriptureJourneys />
        </div>
      </div>
      <CommunityTabs />
      <div className="relative">
        <Navigation />
      </div>
    </div>
  );
}
